import { Navigation } from "@components/Navigation";

export interface DashboardTemplateProps {
  page: React.FunctionComponent;
}

export default function DashboardTemplate({
  page: Page,
}: DashboardTemplateProps) {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Navigation />
      <div className="flex-1 min-h-0 flex flex-col overflow-y-auto">
        <Page />
      </div>
    </div>
  );
}
